/**
 * Created by Victor Rojo on 30/8/18.
 */
import {Component, Input, OnDestroy} from '@angular/core';

import {SectionMap} from "../../section/Section";
import {MapDisplayGadgget} from "../../gadget/Gadget";
import {GadgetService} from "../../gadget/Gadget.service";
import {IPlaceDataChangeService} from "../../IPlaceDataChange.service";
import {SSEElement, GadgetGroupElement} from "../../element/Element";


@Component({
  selector: 'gadget-map',
  templateUrl: './GadgetMap.html',
  styleUrls: ['./GadgetMap.css']
})
export class GadgetMapComponent implements OnDestroy {
  private _sectionMaps: SectionMap[];
  currentSectionMap: SectionMap;
  gadgets: MapDisplayGadgget[];
  gadgetElements: GadgetGroupElement[];
  subscriptions: any[] = [];

  constructor(private gadgetService: GadgetService,
              private iPlaceDataChangeService: IPlaceDataChangeService) {
    this.subscriptions.push(this.iPlaceDataChangeService.elementChange$.subscribe( (element:SSEElement) => {
      this.gadgetElements.filter(gadgetElement => gadgetElement.elementId == element.id)
        .forEach((gadgetElement: GadgetGroupElement) => {
          gadgetElement.name = element.name;
          gadgetElement.value = element.value;
          gadgetElement.status = element.status;
          gadgetElement.updateDate = element.updateDate;
          gadgetElement.lastStatusChange = element.lastStatusChange;
        })
    }));
  }

  get sectionMaps(): SectionMap[] {
    // transform value for display
    return this._sectionMaps;
  }

  @Input()
  set sectionMaps(sectionMaps: SectionMap[]) {
    this._sectionMaps = sectionMaps;
    this.selectSectionMap(sectionMaps.filter(sectionMap => sectionMap.selected)[0]);
  }

  private selectSectionMap(sectionMap: SectionMap){
    this.currentSectionMap = sectionMap;
    this.gadgets = [];
    this.gadgetService.get(this.currentSectionMap.mapId).then((gadgets:MapDisplayGadgget[]) => {
      this.gadgets = gadgets;
      this.gadgetElements = [];
      gadgets.forEach((gadget: MapDisplayGadgget) => this.gadgetElements.push(...gadget.elements));
    })
  }

  onChangeSectionMap(sectionMap: SectionMap) {
    this.selectSectionMap(sectionMap);
  }

  trackGadget(index:number, gadget:MapDisplayGadgget) {
    return gadget ? gadget.gadgetId : undefined;
  }

  public ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }
}
